import { render } from "./Kontakt.vue?vue&type=template&id=f93b57a4&scoped=true"
import script from "./Kontakt.vue?vue&type=script&lang=js"
export * from "./Kontakt.vue?vue&type=script&lang=js"

import "./Kontakt.vue?vue&type=style&index=0&id=f93b57a4&scoped=true&lang=css"

import exportComponent from "C:\\Git-Local\\afm.git - Kopie\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f93b57a4"]])

export default __exports__